import IngresosQuimicosYColorantesScreen from "../../Screen/Inventario/InventarioQuimicosYColorantes/Ingresos/IngresosQuimicosYColorantesScreen";
import IngresosBodegaMaterialesScreen from "../../Screen/Mantenimiento/IngresosMantenimiento/IngresosBodegaMaterialesScreen";
import IngresosCombustibleScreen from "../../Screen/Inventario/InventarioCombustibles/Ingresos/IngresosCombustibleScreen";
import IngresosHilazaScreen from "../../Screen/Produccion/BodegaHilaza/IngresosHilaza/IngresosHilazaScreen";
import InventarioMensualScreen from "../../Base/Screens/Inventarios/BodegaMateriales/InventarioMensualScreen";
import InventarioMensualQC from "../../Base/Screens/Inventarios/QuimicosColorantes/InventarioMensualQC";
import InventarioMensualHilazaScreen from "../../Base/Screens/Inventarios/BodegaHilaza/InventarioMensualHilazaScreen";
import InventarioCombustibleScreen from "../../Base/Screens/Inventarios/Combustibles/InventarioCombustibleScreen";

export const InventarioRoutes = [
  {
    path: "BodegaMateriales/Ingresos",
    permiso: 124,
    element: <IngresosBodegaMaterialesScreen />,
  },
  {
    path: "BodegaMateriales/InventarioMensual",
    permiso: 141,
    element: <InventarioMensualScreen />,
  },
  {
    path: "QuimicosyColorantes/IngresosQuimicos",
    permiso: 125,
    element: <IngresosQuimicosYColorantesScreen />,
  },
  {
    path: "QuimicosColorantes/InventarioQC",
    permiso: 142,
    element: <InventarioMensualQC />,
  },

  {
    path: "Combustibles/Ingresos",
    permiso: 126,
    element: <IngresosCombustibleScreen />,
  },
  {
    path: "Combustibles/InventarioMensual",
    permiso: 144,
    element: <InventarioCombustibleScreen />,
  },

  {
    path: "Hilaza/IngresosHilaza",
    permiso: 130,
    element: <IngresosHilazaScreen IngresoConsolidado={true} />,
  },
  {
    path: "Hilaza/InventarioMensual",
    permiso: 143,
    element: <InventarioMensualHilazaScreen />,
  },
];

export default InventarioRoutes;
